var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/HangingSignV2.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var HangingSignV2 = function HangingSignV2(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30 2c-6.0751 0-11 4.9249-11 11v24c0 1.6569 1.3431 3 3 3h16c1.6569 0 3-1.3431 3-3v-24c0-6.0751-4.9249-11-11-11z",
    fill: "#A6E5FF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.8 11.153h-27.034v-3.953c-0.0463-0.6762-0.6083-1.2011-1.286-1.2011-0.67779 0-1.2398 0.5249-1.286 1.2011v3.953h-3.994c-0.67324 0.0497-1.1941 0.6104-1.1941 1.2855s0.52084 1.2358 1.1941 1.2855h3.994v27.076c0.04621 0.6762 0.60821 1.2011 1.286 1.2011 0.67774 0 1.2397-0.5249 1.286-1.2011v-27.076h5.143v2.576c-1.4187 0.0044-2.5677 1.1533-2.572 2.572v11.566c0.0038 1.4189 1.1531 2.5681 2.572 2.572h18c1.4184-0.0044 2.5671-1.1535 2.571-2.572v-11.571c-0.0066-1.4165-1.1545-2.5626-2.571-2.567v-2.576h3.891c0.6732-0.0497 1.194-0.6104 1.194-1.2855s-0.5208-1.2358-1.194-1.2855zm-3.891 19.285h-18v-11.571h18v11.571zm-15.429-14.138h12.857v-2.576h-12.857v2.576z",
    clipRule: "evenodd",
    fill: "#0D4599",
    fillRule: "evenodd",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.992 22.14-2.327 1.851-0.463-0.475c-0.5063-0.4901-1.3121-0.4837-1.8105 0.0145-0.4985 0.4981-0.5053 1.3039-0.0155 1.8105l1.286 1.286c0.2445 0.2379 0.5718 0.3716 0.913 0.373 0.2917 0.0029 0.575-0.0974 0.8-0.283l3.214-2.571c0.3583-0.2847 0.5375-0.739 0.4701-1.1917s-0.3712-0.8351-0.797-1.003c-0.4257-0.168-0.9088-0.096-1.2671 0.1887h-3e-3z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }));
};

HangingSignV2.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
HangingSignV2.defaultProps = {
  className: null
};
export default HangingSignV2;